import React from "react";
import { Colors } from "../../../configs";
import { Box, Typography } from "@mui/material";
import { CustomButton } from "../../atoms";
import CustomModal from "../../common/custom-modal/custom-modal";

interface WarningDialogProps {
    open: boolean;
    onClose: () => void;
    onOk: () => void;
    message: string;
}

const WarningDialog: React.FC<WarningDialogProps> = ({
    open,
    onClose,
    onOk,
    message,
}) => {
    return (
        <CustomModal
            mode="modal"
            title="Warning"
            onClose={onClose}
            openModal={open}
            width="43rem"
            // height="auto" // Let height adjust to content, or set specific if needed
            backdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    backdropFilter: "blur(0.25rem)",
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.5rem",
                    height: "100%", // Fill modal height
                    mt: 2,
                }}
            >
                <Typography
                    sx={{
                        fontSize: "1.25rem",
                        textAlign: "left",
                        fontWeight: 500,
                        color: Colors.TEXT_GRAY_DARK,
                        whiteSpace: "pre-line", // Handle newlines in message
                    }}
                >
                    {message}
                </Typography>

                <Box sx={{ flex: 1 }} />

                <CustomButton
                    onClick={onOk}
                    sx={{
                        background: Colors.PRIMARY,
                        fontSize: "1.5rem",
                        padding: "0.75rem 3rem",
                        borderRadius: "0.5rem",
                        width: "100%",
                        textTransform: "capitalize",
                        fontWeight: 600,
                        mb: 4,
                        "&:hover": {
                            background: Colors.PRIMARY_DARK,
                        },
                    }}
                >
                    Ok
                </CustomButton>
            </Box>
        </CustomModal>
    );
};

export default WarningDialog;
